import { WalletAdapter, WalletEnvironment, walletError } from '../types'
import { loadScript } from '../../loadScript'

/** Adres SDK Google jest globalny (nie zależy od operatora), więc jako jedyny jest tu na sztywno. */
const GPAY_SDK = 'https://pay.google.com/gp/p/js/pay.js'

let client: any = null
let clientEnvironment = ''

const getClient = async ({ sandbox }: WalletEnvironment = {}) => {
  await loadScript(GPAY_SDK)
  const api = window.google?.payments?.api
  if (!api) throw walletError('wallet_sdk_not_loaded')

  const environment = sandbox ? 'TEST' : 'PRODUCTION'
  if (!client || clientEnvironment !== environment) {
    client = new api.PaymentsClient({ environment })
    clientEnvironment = environment
  }
  return client
}

/** tokenizationSpecification jest jedyną rzeczą, która różni bramki - resztę arkusza mamy wspólną */
const allowedPaymentMethod = (walletForm: payments.WalletForm) => ({
  type: 'CARD',
  parameters: {
    allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
    allowedCardNetworks: walletForm.supportedNetworks
  },
  tokenizationSpecification: {
    type: 'PAYMENT_GATEWAY',
    parameters: {
      gateway: walletForm.gateway,
      gatewayMerchantId: walletForm.gatewayMerchantId
    }
  }
})

export const googlePayAdapter: WalletAdapter = {
  async isAvailable(walletForm, environment) {
    if (!walletForm?.gateway || !walletForm?.gatewayMerchantId) return false
    try {
      const paymentsClient = await getClient(environment)
      const response = await paymentsClient.isReadyToPay({
        apiVersion: 2,
        apiVersionMinor: 0,
        allowedPaymentMethods: [allowedPaymentMethod(walletForm)]
      })
      return !!response?.result
    } catch (_) {
      return false
    }
  },

  async requestToken(walletForm, { amount, label, sandbox, posId }) {
    const paymentsClient = await getClient({ sandbox, posId })
    try {
      const data = await paymentsClient.loadPaymentData({
        apiVersion: 2,
        apiVersionMinor: 0,
        allowedPaymentMethods: [allowedPaymentMethod(walletForm)],
        merchantInfo: { merchantName: label },
        transactionInfo: {
          totalPriceStatus: 'FINAL',
          totalPrice: amount.toFixed(2),
          currencyCode: walletForm.currencyCode,
          countryCode: walletForm.countryCode
        }
      })

      const token = data?.paymentMethodData?.tokenizationData?.token
      if (!token) throw walletError('wallet_token_missing')
      return token as string

    } catch (error: any) {
      if (error?.code) throw error
      if (error?.statusCode === 'CANCELED') throw walletError('wallet_cancelled')
      throw walletError('wallet_failed', error?.statusMessage)
    }
  },

  async createButton(walletForm, onClick, environment) {
    const paymentsClient = await getClient(environment)
    return paymentsClient.createButton({ buttonType: 'pay', buttonSizeMode: 'fill', onClick })
  }
}
